import { Button, Form, Modal } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../../hooks/use-app-dispatch';
import { type RootState } from '../../reducers';
import {
  discountAssignToCustomers,
  discountsLoad,
} from '../../reducers/discount/reducer';
import CustomerPicker from './customer-picker';

interface IFormValues {
  customerUuids: string[];
}

function DiscountAssignModal({
  open,
  onClose,
  discountUuids,
}: {
  open: boolean;
  onClose: () => void;
  discountUuids: string[];
}): React.ReactElement {
  const dispatch = useAppDispatch();
  const inProcess = useSelector((s: RootState) => s.Discount.inProcess);
  const [form] = Form.useForm<IFormValues>();

  const handleFinish = ({ customerUuids }: IFormValues): void => {
    dispatch(discountAssignToCustomers(discountUuids, customerUuids));
    dispatch(discountsLoad());
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title={`Assign ${discountUuids.length} coupon${discountUuids.length === 1 ? '' : 's'} to customers`}
      open={open}
      onCancel={onClose}
      footer={null}
      destroyOnHidden
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          name="customerUuids"
          label="Customers"
          rules={[{ required: true }]}
        >
          <CustomerPicker disabled={inProcess} />
        </Form.Item>

        <Button
          type="primary"
          htmlType="submit"
          disabled={inProcess}
          loading={inProcess}
        >
          Assign
        </Button>
      </Form>
    </Modal>
  );
}

export default DiscountAssignModal;
